<template>
<div class="getJobBiaoZhunDetail">
  <div class="projectName">{{ listDetail.name }}</div>
  <div class="bgf">
    <div class="project-info" v-if="tenderFlag === 2">
      <div class="announcementTitle" v-if="listDetail.oldInfo">澄清后公告：</div>
      <projectInfo :project="listDetail"  :projectId="$route.query.projectId" :oldInfo="0"/>
      <div class="announcementTitle" v-if="listDetail.oldInfo">原公告：</div>
      <projectInfo :project="listDetail.oldInfo"  :projectId="$route.query.projectId" :oldInfo="1" :typeText="'你已投标'"/>
    </div>

    <div class="project-info" v-else>
      <div class="announcementTitle" v-if="listDetail.oldInfo">澄清后公告：</div>
      <projectInfo :project="listDetail"  :projectId="$route.query.projectId" :oldInfo="0"/>
      <div class="announcementTitle" v-if="listDetail.oldInfo">原公告：</div>
      <projectInfo :project="listDetail.oldInfo"  :projectId="$route.query.projectId" :oldInfo="1"/>
    </div>
    <div class="button">
      <el-button type="warning" class="btWith_100 btnHeight_40" block @click.stop="apply" v-if="tenderFlag === 0 && signFlag === 1">报名</el-button>
      <el-button type="info" color="#999999" class="btWith_100 btnHeight_40" block @click.stop="apply" v-if="tenderFlag === 0 && signFlag === 0">报名</el-button>
      <el-button type="warning" class="btWith_100 btnHeight_40" block @click.stop="bid" v-if="tenderFlag === 1">投标</el-button>
    </div>
  </div>

</div>
</template>

<script>
import projectInfo from '@views/components/projectInfo'
import { getNormalProjectInfo, getProjectTenderFlag, signIn } from '@api/project'
export default {
  name: 'getJobBiaoZhunDetail',
  components: { projectInfo },
  data () {
    return {
      listDetail: {},
      tenderFlag: '', // 投标状态：0-未报名；1-已报名未投标；2-已投标
      signFlag: ''
    }
  },
  created () {
    this.getProjectTenderFlag()
    this.getNormalProjectInfo()
  },
  methods: {
    // 获取项目详情
    getNormalProjectInfo () {
      getNormalProjectInfo({ id: this.$route.query.projectId }).then(res => {
        if (res.data.code === 200) {
          this.listDetail = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getProjectTenderFlag () {
      getProjectTenderFlag({
        projectId: this.$route.query.projectId
      }).then(res => {
        if (res.data.code === 200) {
          this.tenderFlag = res.data.data.tenderFlag
          this.signFlag = res.data.data.signFlag
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    apply () {
      signIn({
        projectId: this.$route.query.projectId
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.isEnough === 0) {
            // 人数是否够：1-够；0-不够
            this.$dialog.confirm({
              title: '提示',
              message: '你的队伍规模不满足投标条件，无法报名，请添加人员。',
              confirmButtonText: '立即添加'
            }).then(() => {
              // 添加人员 和客户端交互
              this.$bridge.callHandler('orgParticipantList', response => {
                console.log('response:', response)
              })
            }).catch(() => {
              // on cancel
            })
          } else {
            this.$message.success('报名成功')
            this.getProjectTenderFlag()
            this.getNormalProjectInfo()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    bid () {
      this.enterRouter('bidPage', { projectId: this.$route.query.projectId })
    },
  }
}
</script>

<style scoped lang="scss">
.getJobBiaoZhunDetail{
  width: 75%;
.button{
  width: 140px;
  margin: 0 auto;
}
}
</style>
